import { render, staticRenderFns } from "./Page-8.vue?vue&type=template&id=3189d884&scoped=true&"
var script = {}
import style0 from "./Page-8.vue?vue&type=style&index=0&id=3189d884&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189d884",
  null
  
)

export default component.exports